import React from 'react';
import BreadcrumbsComponent from '@mui/material/Breadcrumbs';

import Typography from '../Typography';
import Breadcrumb from './components/Breadcrumb';
import useChildrenRenderer from './hooks/useChildrenRenderer';
import { BreadcrumbProps, BreadcrumbsProps } from './types';

const Breadcrumbs: React.FC<React.PropsWithChildren<BreadcrumbsProps>> = ({
  children,
  className,
  itemsToShowAfterCollapse = 2,
  itemsToShowBeforeCollapse = 1,
  maxItems = 8,
}) => {
  const childrenToRender = useChildrenRenderer({
    children,
    itemsToShowAfterCollapse,
    itemsToShowBeforeCollapse,
  });

  return (
    <BreadcrumbsComponent
      children={childrenToRender}
      className={className}
      maxItems={maxItems}
      separator={<Typography variant="body-short-02">/</Typography>}
    />
  );
};

export { Breadcrumb, BreadcrumbProps };
export default Breadcrumbs;
